<template>
  <div class="text-center my-5">
    <div>본인인증에 실패했습니다.</div>
    <mdb-btn @click="onOk" class="my-5" icon="close">닫기</mdb-btn>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'JoinAuthFail',
  components: {},
  props: [],
  data: () => ({
    TAG: 'JoinAuthSuccess :'
  }),
  computed: {
  },
  methods: {
    onOk () {
      window.close()
    }
  }
}
</script>
